var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayersPassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.86 7.92a2.6 2.6 0 0 1-1.013-.193L2.913 5.98c-1-.447-1.146-1.047-1.146-1.373s.146-.927 1.146-1.374l3.934-1.746c.58-.26 1.453-.26 2.033 0l3.94 1.746c.993.44 1.147 1.047 1.147 1.374 0 .326-.147.926-1.147 1.373L8.88 7.727c-.293.133-.653.193-1.02.193m0-5.627a1.5 1.5 0 0 0-.607.107L3.32 4.147c-.407.186-.553.373-.553.46 0 .086.146.28.546.46l3.934 1.746c.32.14.9.14 1.22 0l3.94-1.746c.406-.18.553-.374.553-.46s-.147-.28-.553-.46L8.473 2.4a1.7 1.7 0 0 0-.613-.107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.393c-.253 0-.507-.053-.747-.16L2.727 9.22C2.04 8.92 1.5 8.087 1.5 7.333c0-.273.227-.5.5-.5s.5.227.5.5c0 .367.3.827.633.98l4.527 2.014c.213.093.46.093.68 0l4.527-2.014c.333-.146.633-.613.633-.98 0-.273.227-.5.5-.5s.5.227.5.5c0 .754-.54 1.587-1.227 1.894L8.747 11.24c-.24.1-.494.153-.747.153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.727c-.253 0-.507-.054-.747-.16l-4.526-2.014A2.07 2.07 0 0 1 1.5 10.66c0-.273.227-.5.5-.5s.5.233.5.507c0 .42.247.806.633.98L7.66 13.66c.213.093.46.093.68 0l4.527-2.013c.386-.174.633-.554.633-.98 0-.274.227-.5.5-.5s.5.226.5.5c0 .82-.48 1.56-1.227 1.893l-4.526 2.013c-.24.1-.494.154-.747.154"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersPassive);
export default __webpack_public_path__ + "static/media/layersPassive.94fa045a2ce1009b8cd8ae083c29d298.svg";
export { ForwardRef as ReactComponent };